import React, { useEffect, useState } from "react";
import { SingleCardMetric } from "../ui/SingleCardMetric";
import { fetchGroupPossibleParticipants, fetchReportResources } from "../../../services/httpClient";

interface ResourcesMetricState {
  data?: any[];
  useDatePicker?: boolean;
  startDate?: string;
  endDate?: string;
  metricType?: string;
  resourceType?: string;
  population?: any[];
}

export const ResourcesMetric = ({ data, useDatePicker = false, startDate, endDate, metricType, resourceType, population }: ResourcesMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<string>();

  useEffect(() => {
    const fetchData = async () => {
      let resourceData: any = data;
      let populationData: any = population;

      if (!resourceData) {
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        let start = starting.toISOString().slice(0, 10);
        let end = new Date().toISOString().slice(0, 10);

        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }

        resourceData = await getResourceData(start, end);
      }

      if (metricType === "usage" && !populationData) {
        populationData = await getPopulation();
      }

      const result = calculateMetric(resourceData, populationData);
      setTotal(result);
      setIsLoading(false);
    };

    fetchData();
  }, [data, startDate, endDate]);

  const getResourceData = async (start: string, end: string) => {
    const res: any = await fetchReportResources(start, end);
    return res[0]?.data;
  };

  const getPopulation = async () => {
    const res: any = await fetchGroupPossibleParticipants("0");
    return res[0]?.data[0];
  };

  const calculateMetric = (resourceData: any[], populationData: any[]) => {
    if (!metricType) return;

    if (metricType === "people") {
      const peopleAssigned = new Set(resourceData?.map((d) => `${d.assignee_id}|${d.assignee_type}`)).size;
      return peopleAssigned.toString();
    }

    if (metricType === "resources") {
      return resourceData?.filter((d) => d.resource_type_key === resourceType).length.toString();
    }

    if (metricType === "usage" && populationData) {
      const peopleAssigned = new Set(resourceData?.map((d) => `${d.assignee_id}|${d.assignee_type}`)).size;
      const usage = populationData.length === 0 ? "0.0" : ((peopleAssigned / populationData.length) * 100).toFixed(1);
      return usage;
    }
  };

  const resourceLabel = resourceType === "consumable" ? "Consumables" : "Non-Consumables";
  const title = metricType === "usage" ? "Resource Usage %" : metricType === "resources" ? `${resourceLabel} Assigned` : `People Assigned Resources`;

  return (
    <SingleCardMetric title={title} total={total} isLoading={isLoading} />
  );
};
